/*
 * @description: 活动标题 只有活动信息的商品才会展示阶梯活动时
 * @update: 添加弹框查看活动
 * @Author: tangxq
 * @Date: 2021-06-08 09:58:29
 * @Last Modified by: tangxq
 * @Last Modified time: 2021-06-09 10:32:56
 */

<template>
  <div class="out-box">
    <!-- <div class="check-box">
        <van-checkbox
            v-model="value"
            @change="checkedActiveTagChange"
            checked-color="#FF3939"
            icon-size="0.38rem"
        />
      </div> -->
    <div
      :class="['tag-box', themeType, { 'is-meet': isMeet }]"
      @click.self="toggleMoreActive"
    >
      <div
        class="left-info"
        @click.stop="toggleMoreActive"
      >
        <goods-item-tag
          :text="tagName"
          :bg-color="getGoodsTagBg"
        />
        <span
          class="van-ellipsis content-tips"
          style="max-width: 30vw;"
        >{{ getTagContent }}</span>
      </div>
      <div
        class="to-link"
        @click.stop="toBuy"
      >
        <span class="btn">去加购</span>
        <van-icon
          name="arrow"
          :color="rightIconColor"
          size="6px"
        />
      </div>
    </div>
    <!-- 多阶梯展示弹框 -->
    <van-dialog
      v-model="showMoreActive"
      title="商品活动说明"
      confirm-button-text="知道啦～"
      confirm-button-color="#0F6EEA"
      get-container="body"
      width="500"
    >
      <div class="more-active-content">
        <p
          v-for="(item, index) in getMoreActiveInfoStr().split('；')"
          :key="index"
          class="more-avtive-item"
        >
          {{ index + 1 }}、{{ item }}。
        </p>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import { BaseMixin } from '@/mixins/BaseMixin'
import GoodsItemTag from './BuyCarItemTag.vue'
export default {
  name: '',
  components: { GoodsItemTag },
  mixins: [BaseMixin],
  // 页面数据部分
  props: {
    // themeType: {
    //   type: String,
    //   default: 'full-minus', // 默认满减
    // },
    groupInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      showMoreActive: false,
      themeType: 'full-minus',
      // getGoodsTagBg: '',
      value: true,
      isMeet: false, // 活动组商品是否满足当前活动内容
      multipeNum: 1 // 每满， 每买 满足活动的次数
    }
  },
  computed: {
    getTagContent() {
      return this.getActiveContent()
    },
    // 活动标签背景色
    getGoodsTagBg() {
      const { isMeet } = this
      const {
        Activity: { Type }
      } = this.groupInfo
      if (!isMeet) {
        return 'transparent'
      }
      if (Type === 1) {
        // 商城
        return 'linear-gradient(45deg, #FF6831 0%, #F3180E 100%)'
      } else {
        return 'linear-gradient(328deg, #4898FF 0%, #0F6EEA 100%)'
      }
    },
    // 从活动中获取当前活动标签名称
    tagName() {
      const { Activity } = this.groupInfo
      return Activity.Tags[0] ? Activity.Tags[0].TagName : ''
    },
    rightIconColor() {
      const { themeType, isMeet } = this
      if (isMeet) {
        return '#0F6EEA'
      }
      return '#ffffff'
    }
  },
  watch: {
    'groupInfo.GoodsSkus': {
      handler(val) {
        // console.log('goodsSkus--->改变')
        // console.log(val)
        this.setMeet()
      },
      immediate: true,
      deep: true
    },
    'groupInfo.Activity': {
      handler(v) {
        if (v) {
          const { Type } = v
          if (Type === 1) {
            // 商城
            this.themeType = 'store'
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  // 页面生命周期
  created() { },
  mounted() { },
  unmounted() { },
  // 页面内方法
  methods: {
    // 多阶梯活动配置查看弹框
    toggleMoreActive() {
      try {
        this.showMoreActive = !this.showMoreActive
      } catch (error) {
        console.log(error)
      }
    },
    initGroupCustomPrice() {
      this.isMeet = false
      const { GoodsSkus } = this.groupInfo // 当前活动组所有商品
      this.groupInfo.customGroupMoney = null
      for (let index = 0; index < GoodsSkus.length; index++) {
        const element = GoodsSkus[index]
        // 每个商品所占比例
        element.customScale = null
        // 每个商品所占的金额比例，分摊到具体一个商品金额
        element.customNewActivePrice = null
        element.customGroupMoney = null
      }
    },
    // 每买、每满是判断当前数值书否是活动数值的倍数（金额或者数量）
    isMultipleNum(num, MultipleNum) {
      return num % MultipleNum === 0
    },
    // 获取倍数
    getMultipe(num, MultipleNum) {
      return parseInt(num / MultipleNum) || 1
    },
    // 满足活动商品选中
    checkedActiveTagChange(val) {
      // console.log(val)
    },
    getSendActiveText(showDefaultConfig) {
      let giftTypeMsg = ''
      const { Activity = {}} = this.groupInfo
      const { Configs, ConditionType, Type: ActivityType } = Activity
      const {
        Discount,
        DiscountType,
        ActivityConfigPresent,
        ConditionValueType,
        Condition
      } = showDefaultConfig
      giftTypeMsg += `${
        // ActivityType === 1 ? "指定商品订单金额" : "指定专区商品订单金额"
        ActivityType === 1 ? '' : ''
      }`
      // 未满足时
      giftTypeMsg +=
                ConditionType == 1
                  ? '满'
                  : ConditionType == 2
                    ? '每满'
                    : ConditionType == 3
                      ? '买'
                      : '每买'
      giftTypeMsg += Condition
      giftTypeMsg += ConditionValueType == 1 ? '元' : '盒'
      // 条件值类型   折扣 = 2, 金额 = 1,
      if (DiscountType) {
        giftTypeMsg += DiscountType == 1 ? '减' : '享受'
      }
      if (Discount) {
        giftTypeMsg += Discount
      }
      if (DiscountType && DiscountType === 2) {
        giftTypeMsg += '折'
      }
      giftTypeMsg += this.getGiftContent(ActivityConfigPresent)
      return giftTypeMsg
    },
    getGiftContent(giftArr) {
      if (!giftArr.length) {
        return ''
      }
      let giftShowContent = '，并赠送'
      giftArr.forEach((item, index) => {
        giftShowContent += `${item.Name ?? ''}*${item.Amount}${
          index < giftArr.length - 1 ? '、' : ''
        }`
      })
      return giftShowContent
    },
    // 加购商品
    toBuy() {
      try {
        const { Activity = {}} = this.groupInfo
        const { Id } = Activity
        const str = this.getMoreActiveInfoStr()
        this._jump(
          this.Enum_LinkTypeCode.ActivityProductList,
          {
            id: Id,
            str
          },
          '_blank'
        )
      } catch (error) {
        console.log(error)
      }
    },
    getMoreActiveInfoStr() {
      const { Activity = {}} = this.groupInfo
      const { Configs } = Activity
      let str = ''
      if (Configs.length) {
        Configs.forEach((element, index) => {
          str += this.getSendActiveText(element, Activity)
          if (index < Configs.length - 1) {
            str += '；'
          }
        })
      }
      return str
    },
    changeString(children, item) {
      let str = ''
      str =
                item.ConditionType == 1
                  ? '满'
                  : item.ConditionType == 2
                    ? '每满'
                    : item.ConditionType == 3
                      ? '买'
                      : '每买'
      str = str + children.Condition.toString()
      str = str + (children.ConditionValueType == 1 ? '元' : '个')
      str = str + (children.DiscountType == 1 ? '减' : '总价打')
      str = str + children.Discount.toString()
      str = str + (children.DiscountType == 2 ? '折' : '')
      str =
                str +
                (children.ActivityConfigPresent.length > 0
                  ? ',并赠送' +
                    children.ActivityConfigPresent[0].Name +
                    children.ActivityConfigPresent[0].Amount
                  : '')
      return str
    },
    // 判断选中商品信息当前信息是否满足当前所属活动规则
    setMeet() {
      // ConfigType ：
      // 商品=1, //按商品
      // / 订单=2 //按订单
      // ConditionType：
      // / 条件类型
      // / 满=1,
      // / 每满=2,
      // / 买=3,
      // / 每买=4
      // Condition
      const { Activity = {}} = this.groupInfo
      const { ConfigType, Configs, ConditionType } = Activity
      const { GoodsSkus } = this.groupInfo // 当前活动组所有商品

      const groupAllMoney = GoodsSkus.reduce((add, item) => {
        const calcPrice = item.ActivityPrice ?? item.PriceLimit
        return add + calcPrice * item.Count
      }, 0) // 当前订单或商城按订单配置-指定商品的  总价集合

      const userChooseGoodsSkus = GoodsSkus.filter((item) => item.checked)
      const userChooseGoodsAllMoney = userChooseGoodsSkus.reduce(
        (add, item) => {
          const calcPrice = item.ActivityPrice ?? item.PriceLimit
          return add + calcPrice * item.Count
        },
        0
      )
      // console.log('选中商品总价--->', userChooseGoodsAllMoney)
      if (userChooseGoodsAllMoney === 0) {
        this.initGroupCustomPrice()
        return
      }
      //  获取已满足的条件
      let userMeetConfig = null
      let lastCondition = 0
      Configs.forEach((element) => {
        if (
          userChooseGoodsAllMoney >= element.Condition &&
                    element.Condition >= lastCondition
        ) {
          lastCondition = element.Condition
          userMeetConfig = element
        }
      })
      // console.log('当前满足的条件--->', userMeetConfig)
      // console.log('用户选中的商品--->', userChooseGoodsSkus)
      // 当前根据订单来配置
      if (userMeetConfig && ConfigType === 2 && ConditionType === 1) {
        // 订单配置的满减
        // 满多少
        // 按订单配置
        // 获取最高满金额或数量的配置
        const maxRight = Configs.sort((a, b) => {
          return b.Condition - a.Condition
        })[0]
        // const maxRightItem = Math.max.apply(Math, Configs.map(item => item.Condition))

        // console.log('最高层级优惠金额或数量配置--->', maxRight)
        const { Discount, DiscountType } = userMeetConfig
        // console.log(
        //   '当前所选商品满足优惠力度--->',
        //   `${DiscountType === 2 ? '折扣' : '减金额'}${Discount}`
        // )
        // 已满足最高条件金额
        this.isMeet = true
        const newActiveMoney =
                    DiscountType === 2
                      ? userChooseGoodsAllMoney * (Discount / 10)
                      : userChooseGoodsAllMoney - Discount
        // console.log('优惠后订单价--->', newActiveMoney)
        this.groupInfo.customGroupMoney = newActiveMoney
        for (let index = 0; index < userChooseGoodsSkus.length; index++) {
          const element = userChooseGoodsSkus[index]
          // 每个商品所占比例
          //   element.customScale = (
          //     (element.ActivityPrice * element.Count) /
          //     userChooseGoodsAllMoney
          //   ).toFixed(2);
          //   // 每个商品所占的金额比例，分摊到具体一个商品金额
          //   element.customNewActivePrice = (
          //     (element.customScale * newActiveMoney) /
          //     (element.Count || 1)
          //   ).toFixed(2);
          element.customGroupMoney = newActiveMoney
        }
      } else if (userMeetConfig && ConfigType === 2 && ConditionType === 2) {
        // 每满只减钱，不打折
        const { Condition, Discount, DiscountType } = userMeetConfig
        // console.log(
        //   '当前所选商品满足优惠力度--->',
        //   `${DiscountType === 2 ? '折扣' : '每满'}${Condition}减${Discount}`
        // )
        // 每满优惠
        // 判断当前活动商品组 每满的次数
        // 配置的每满价格
        const multNum = this.getMultipe(userChooseGoodsAllMoney, Condition) // 当前选中价格是条件的多少倍
        this.multipeNum = multNum
        console.log(multNum)
        if (multNum >= 1) {
          // 满足满减
          this.isMeet = true
          // 满足的倍数
          // 总共减多少钱
          const allRightPrice = Number((multNum * Discount).toFixed(2))
          const newActivePrice = Number(
            (userChooseGoodsAllMoney - allRightPrice).toFixed(2)
          )
          this.groupInfo.customGroupMoney = newActivePrice
          for (let index = 0; index < userChooseGoodsSkus.length; index++) {
            const element = userChooseGoodsSkus[index]
            element.customGroupMoney = newActivePrice
          }
        }
      } else {
        // console.log('未满足条件')
        this.initGroupCustomPrice()
      }
      // console.log('---->当前活动分组所有商品活动总价', groupAllMoney)
      // this.isMeet = false
    },
    getActiveContent() {
      let giftTypeMsg = ''
      // multipeNum 是每买，每满时，当前满足活动规则的倍数
      const { isMeet, multipeNum } = this
      const { Activity = {}} = this.groupInfo
      const { Configs, ConditionType, Type: ActivityType } = Activity
      const { GoodsSkus } = this.groupInfo // 当前活动组所有商品
      const userChooseGoodsSkus = GoodsSkus.filter((item) => item.checked)
      const userChooseGoodsAllMoney = userChooseGoodsSkus.reduce(
        (add, item) => {
          const calcPrice = item.ActivityPrice ?? item.PriceLimit
          return add + calcPrice * item.Count
        },
        0
      )
      //  获取已满足的条件
      let userMeetConfig = null
      let lastCondition = 0
      Configs.forEach((element) => {
        if (
          userChooseGoodsAllMoney >= element.Condition &&
                    element.Condition >= lastCondition
        ) {
          lastCondition = element.Condition
          userMeetConfig = element
        }
      })
      // console.log('展示内容满足活动的配置---》', userMeetConfig)
      //   排序后取第一个
      const showDefaultConfig = Configs.sort((a, b) => {
        return a.Condition - b.Condition
      })[0]
      // console.log('为满足-默认展示条件配置---->', showDefaultConfig)

      if (!userMeetConfig) {
        // 未满足
        const {
          Discount,
          DiscountType,
          ActivityConfigPresent,
          ConditionValueType,
          Condition
        } = showDefaultConfig
        giftTypeMsg += `${
          ActivityType === 1 ? '指定商品订单金额' : '指定专区商品订单金额'
        }`
        // 未满足时
        giftTypeMsg +=
                    ConditionType == 1
                      ? '满'
                      : ConditionType == 2
                        ? '每满'
                        : ConditionType == 3
                          ? '买'
                          : '每买'
        giftTypeMsg += Condition
        giftTypeMsg += ConditionValueType == 1 ? '元' : '盒'
        // 条件值类型   折扣 = 2, 金额 = 1,
        if (DiscountType) {
          giftTypeMsg += DiscountType == 1 ? '减' : '享受'
        }
        if (Discount) {
          giftTypeMsg += Discount
        }
        if (DiscountType && DiscountType === 2) {
          giftTypeMsg += '折'
        }
        giftTypeMsg += this.getGiftContent(ActivityConfigPresent)
      } else {
        // 已满足
        const {
          Discount,
          DiscountType,
          ActivityConfigPresent,
          ConditionValueType,
          Condition
        } = userMeetConfig
        // 如果是每买、每满  需乘以满足活动的次数

        if (ConditionType === 1 || ConditionType === 3) {
          if (DiscountType) {
            giftTypeMsg += DiscountType == 1 ? '已减' : '已享受'
            giftTypeMsg += Discount
            giftTypeMsg += DiscountType == 1 ? '元' : '折'
          }
          if (ActivityConfigPresent && ActivityConfigPresent.length) {
            giftTypeMsg += this.getGiftIsmeetContent(ActivityConfigPresent)
          }
        }

        // 如果是每买、每满  提示继续赠送的信息
        if (ConditionType === 2 || ConditionType === 4) {
          if (DiscountType) {
            giftTypeMsg += DiscountType == 1 ? '已减' : '已享受'
            giftTypeMsg += Discount * multipeNum || 1
            giftTypeMsg += DiscountType == 1 ? '元' : '折'
          }
          if (ActivityConfigPresent && ActivityConfigPresent.length) {
            giftTypeMsg += this.getGiftIsmeetContent(ActivityConfigPresent)
          }
          if (DiscountType) {
            giftTypeMsg += `，再买${Condition}`
            giftTypeMsg += DiscountType == 1 ? '减' : '享受'
            giftTypeMsg += Discount
            giftTypeMsg += DiscountType == 1 ? '元' : '折'
          }
        }
      }

      return giftTypeMsg
    },
    /**
         * 根据赠品返回对应赠品信息文字
         */
    getGiftContent(giftArr) {
      if (!giftArr.length) {
        return ''
      }
      let giftShowContent = '，并赠送'
      giftArr.forEach((item, index) => {
        giftShowContent += `${item.Name ?? ''}*${item.Amount}${
          index < giftArr.length - 1 ? '、' : ''
        }`
      })
      return giftShowContent
    },
    getGiftIsmeetContent(giftArr) {
      const { multipeNum } = this
      if (!giftArr.length) {
        return ''
      }
      let giftShowContent = '，并赠送'
      giftArr.forEach((item, index) => {
        giftShowContent += `${item.Name ?? ''}*${item.Amount * multipeNum}${
          index < giftArr.length - 1 ? '、' : ''
        }`
      })
      return giftShowContent
    }
  }
}
</script>
<style lang="less" scoped>
.more-active-content {
  overflow: auto;
  padding: 15px 20px;
  max-height: 60vh;

  .more-avtive-item {
    margin: 0 0 10px;
    font-size: 14px;
    color: #222222;

    &:last-child {
      margin: 0;
    }
  }
}

.out-box {
  display: flex;
  justify-content: space-between;
  height: 40px;
  background: #FFFFFF;
  cursor: pointer;
  // padding-left: 20px;
  .check-box {
    padding: 0 .18rem;
    box-sizing: border-box;
  }
}

.tag-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 2px 2px 0 0;
  padding: 0 20px;
  height: 100%;
  font-size: 14px;
  box-sizing: border-box;
  flex: 1;

  &.full-minus {
    color: #FFFFFF;
    background: linear-gradient(328deg, #4898FF 0%, #0F6EEA 100%);

    &.is-meet {
      color: #111A34;
      background: #ECF5FF;

      .to-link {
        color: #0F6EEA;
      }
    }
  }

  &.store {
    color: #FFFFFF;
    background: linear-gradient(45deg, #FF6831 0%, #F3180E 100%);

    &.is-meet {
      color: #111A34;
      background: #FFEEEC;

      .to-link {
        color: #0F6EEA;
      }
    }
  }

  .to-link,
  .left-info {
    display: flex;
    align-items: center;
    cursor: pointer;

    .btn {
      margin-right: 8px;
    }
  }
}
</style>
